import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export interface TextConfig {
  title: string;
  subtitle: string;
  cta: string;
  price: string;
  discount: string;
}

interface AdTextEditorProps {
  config: TextConfig;
  onChange: (config: TextConfig) => void;
}

export function AdTextEditor({ config, onChange }: AdTextEditorProps) {
  const updateField = (field: keyof TextConfig, value: string) => {
    onChange({ ...config, [field]: value });
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="title">Titre principal</Label>
          <Input
            id="title"
            placeholder="Ex: Nouvelle Collection 2025"
            value={config.title}
            onChange={(e) => updateField("title", e.target.value)}
            maxLength={50}
          />
          <p className="text-xs text-muted-foreground">{config.title.length}/50</p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="subtitle">Sous-titre</Label>
          <Input
            id="subtitle"
            placeholder="Ex: Qualité premium, prix accessible"
            value={config.subtitle}
            onChange={(e) => updateField("subtitle", e.target.value)}
            maxLength={80}
          />
          <p className="text-xs text-muted-foreground">{config.subtitle.length}/80</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="cta">Bouton CTA</Label>
          <Input
            id="cta"
            placeholder="Ex: Acheter maintenant"
            value={config.cta}
            onChange={(e) => updateField("cta", e.target.value)}
            maxLength={25}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="price">Prix</Label>
          <Input
            id="price"
            placeholder="Ex: 29 900 FCFA"
            value={config.price}
            onChange={(e) => updateField("price", e.target.value)}
            maxLength={20}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="discount">Réduction</Label>
          <Input
            id="discount"
            placeholder="Ex: -30%"
            value={config.discount}
            onChange={(e) => updateField("discount", e.target.value)}
            maxLength={15}
          />
        </div>
      </div>

      <div className="p-4 bg-secondary/50 rounded-lg">
        <h4 className="text-sm font-medium mb-2">Aperçu du texte</h4>
        <div className="space-y-1">
          {config.title && <p className="font-bold text-lg">{config.title}</p>}
          {config.subtitle && <p className="text-muted-foreground">{config.subtitle}</p>}
          <div className="flex items-center gap-3 mt-2">
            {config.price && <span className="font-semibold text-primary">{config.price}</span>}
            {config.discount && (
              <span className="bg-destructive text-destructive-foreground px-2 py-0.5 rounded text-sm font-medium">
                {config.discount}
              </span>
            )}
          </div>
          {config.cta && (
            <button className="mt-2 px-4 py-1.5 bg-primary text-primary-foreground rounded-lg text-sm font-medium">
              {config.cta}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
